import { customFiltersResource } from '@jira/project-settings__custom-filters/src/customFiltersResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareBoardsCustomFiltersRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareBoardsCustomFiltersRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import CustomFiltersSettings, {
	LazyCustomFiltersSettings,
} from './ui/project-settings/custom-filters/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsSoftwareBoardsCustomFiltersRouteEntry: Route = createEntry(
	projectSettingsSoftwareBoardsCustomFiltersRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.custom-filters',
		// eslint-disable-next-line no-restricted-syntax
		component: CustomFiltersSettings,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources(), customFiltersResource],
		forPaint: [LazyAtlassianNavigation, LazyCustomFiltersSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
